import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
import { recentBuyerCities } from '../data/salesContent';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setVisible(true);
      hideTimer = setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % recentBuyerCities.length);
      }, 5500);
    };
    const first = setTimeout(show, 7000);
    const interval = setInterval(show, 16000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, [dismissed]);
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto" aria-live="polite" data-id="element-38" data-mp="1gzozg1g0jzb3">
      <AnimatePresence data-id="element-39" data-mp="164xq93086yn7">
        {visible && !dismissed && <motion.div key={index} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} transition={{
        duration: 0.25,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto relative flex w-full items-start gap-3 rounded-xl border border-gold/40 bg-ink p-3.5 pr-9 shadow-[0_12px_32px_rgba(0,0,0,0.5)] sm:w-80" data-id="element-40" data-mp="116w6efuz6vao">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gold/50 text-gold" data-id="element-41" data-mp="i9uzuqlrwn4m">
              <CheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-42" data-mp="s6hlhhlxbi7p" />
            </span>
            <div className="min-w-0 text-sm leading-snug" data-id="element-43" data-mp="s8kjoox8chni">
              <p className="font-semibold text-gold" data-id="element-44" data-mp="28j53quukuu8a">Compra reciente</p>
              <p className="mt-0.5 text-cream" data-id="element-45" data-mp="23m67o6rcsd7g">
                Una persona de <span className="font-semibold" data-id="element-46" data-mp="23npmru19wi7n">{recentBuyerCities[index]}</span>, Argentina accedió al Sistema Primeros
                Auxilios para Instructores™
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded p-1 text-neutral-500 transition-colors duration-150 hover:text-cream" data-id="element-47" data-mp="2fphb8yud8ccd">
              <XIcon className="h-4 w-4" data-id="element-48" data-mp="1rvz2xcl1jrar" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}